<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-7/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div
        class="sm:flex max-w-2xl"
      >
        <div
          class="text-4xl font-bold mr-10"
        >
          {{ !campaign ? 'Crea' : 'Edita' }} tu campaña
        </div>
        <img
          class="sm:w-2/6 w-64"
          src="@/assets/questions.svg"
        >
      </div>
      <div class="mb-4">
        <label
          class="font-bold text-lg mb-"
          for="name"
        >
          Nombre de la campaña
        </label>
        <input
          ref="categoryInput"
          v-model="name"
          name="name"
          type="text"
          class="rounded-md w-full text-xl px-2 border-2 text-gray-500 border-purple-500 border-opacity-25 focus:border-opacity-100 mt-1"
        >
      </div>
      <tag-manager
        :success="success"
        :selectableTags="tags"
        :currentTags="currentTags"
        :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
        @tag:add="addTag"
        @tag:remove="removeTag"
        @state:search="isSearching = $event"
      >
        <div class="font-bold text-lg mb-">
          Segmenta tu campaña
        </div>
      </tag-manager>
      <div class="flex justify-around">
        <div>
          <div class="font-bold text-lg mt-5 mb-2">
            Fechas para campaña
          </div>
          <vc-date-picker
            v-model="dates"
            class="shadow-md"
            color="purple"
            is-range
            :attributes="attributes"
          />
        </div>
        <div>
          <div class="font-bold text-lg mt-5 mb-2">
            Hora recordatorio
          </div>
          <div class="flex w-full items-center">
            <select
              v-model="hours"
              name="hours"
              class="p-2 bg-gray-200"
            >
              <option
                v-for="hourIndex in 24"
                :key="hourIndex - 1"
                :value="hourIndex - 1"
              >
                {{ hourIndex - 1 }}
              </option>
            </select>
            <span class="text-xl font-bold mx-2">:</span>
            <select
              v-model="minutes"
              name="minutes"
              class="p-2 bg-gray-200"
            >
              <option
                v-for="hourIndex in 60"
                :key="hourIndex - 1"
                :value="hourIndex - 1"
              >
                {{ hourIndex - 1 }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="font-bold text-lg mb-4 mt-8"
      >
        Categorías
      </div>
      <a
        v-if="!isEditing"
        class="sm:w-64 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
        @click="isEditing = true"
      >
        <eva-icon
          name="plus-outline"
          fill="#FFFFFF"
        />
        <div
          class="block-inline text-center w-full"
        >
          Nueva categoría
        </div>
      </a>
      <ValidationObserver
        v-else
        ref="form"
        v-slot="{ handleSubmit }"
      >
        <form
          id="myForm"
          class="min-w-64 my-5 p-4 rounded-md shadow-md text-lg"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          ¿Cómo llamarás esta categoría?
          <ValidationProvider
            v-slot="{ errors, valid }"
            mode="aggressive"
            vid="category"
            name="Categoría"
            :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\- .' ]*$/, required: true }"
          >
            <input
              ref="categoryInput"
              v-model="editingValue"
              name="categoryLabel"
              type="text"
              class="rounded-lg w-full text-2xl px-2 border border-gray-400 focus:bg-gray-200"
            >
            <p class="text-red-500 text-center mx-1">
              {{ errors[0] }}
            </p>
            <div class="flex justify-end">
              <a
                class="sm:w-64 cursor-pointer text-gray flex px-4 py-2 rounded-md items-center text-md mt-4"
                @click="isEditing = false; editingValue = ''"
              >
                <div
                  class="block-inline text-center w-full"
                >
                  Cancelar
                </div>
              </a>
              <button
                type="submit"
                :disabled="!valid"
                class="disabled:opacity-25 disabled:pointer-events-none bg-green-400 sm:w-64 text-white flex px-4 py-2 rounded-md items-center text-md mt-4"
              >
                <eva-icon
                  name="save-outline"
                  fill="#FFFFFF"
                />
                <div
                  class="block-inline text-center w-full"
                >
                  Guardar
                </div>
              </button>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <div
        v-for="categoryID in categoryIDs"
        :key="categoryID"
      >
        <campaign-category-card
          v-if="categoryID === selectedCategoryID"
          :categoryID="categoryID"
          :category="categories[categoryID]"
          @collapse="selectedCategoryID = null"
          @change="onCategoryChange"
          @delete="onCategoryDelete"
        />
        <div
          v-else
          class="cursor-pointer text-lg min-w-64 my-5 p-4 rounded-md shadow-md border-2 border-purple-500 border-opacity-0 hover:border-opacity-100"
          @click="selectedCategoryID = categoryID"
        >
          {{ categories[categoryID].name }}
        </div>
      </div>
      <div class="flex justify-end">
        <a
          class="sm:w-64 cursor-pointer text-gray flex px-4 py-2 rounded-md items-center text-md mt-4"
          @click="$f7router.back()"
        >
          <div
            class="block-inline text-center w-full"
          >
            Cancelar
          </div>
        </a>
        <a
          class="sm:w-64 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
          @click="save"
        >
          <div
            class="block-inline text-center w-full"
          >
            Guardar
          </div>
        </a>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import campaignCategoryCard from '../components/campaignCategoryCard'
import tagManager from '../components/tagManager'
import { db } from '../utils/firebase'
import * as axios from 'axios'

export default {
  components: {
    campaignCategoryCard,
    tagManager,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    campaignID: {
      type: String,
      default: null,
    },
    campaign: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      hours: '6',
      minutes: '15',
      accordion: {
        parameters: false,
        notification: false,
      },
      isEditing: false,
      selectedCategoryID: null,
      selectedFieldID: null,
      newSectionLabel: '',
      editingValue: '',
      name: '',
      campaignTagIDs: {},
      success: false,
      dates: {
        start: moment().toDate(),
        end: moment().add(7, 'days').toDate(),
      },
      form: {
        categories: {},
        categoryIDs: [],
      },
    }
  },
  computed: {
    attributes () {
      return [this.dates].map(date => ({
        highlight: true,
        dates: date,
      }))
    },
    tagsArray () {
      return Object.keys(this.tags).map(tagID => {
        return this.tags[tagID]
      }).sort()
    },
    currentTags () {
      const tags = {}
      if (!this.campaignTagIDs) {
        return tags
      }
      for (const tagID of Object.keys(this.campaignTagIDs)) {
        tags[tagID] = this.tags[tagID]
      }
      return tags
    },
    cronID () {
      return this.instancesInfo[this.instanceID].notificationSettings?.cronID
    },
    maxRiskLevelSum () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.maxRiskLevelSum || 4
    },
    categories () {
      return this.form.categories
    },
    categoryIDs () {
      return this.form.categoryIDs
    },
    askForTemperature () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.askForTemperature
    },
    askTemperatureAccessPoints () {
      const value = this.instancesInfo[this.instanceID].dictionary.parameters.askTemperatureAccessPoints
      return typeof value === 'undefined' ? true : value
    },
    temperatureLimit () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.temperatureLimit || 38
    },
    isDoneReporting () {
      return Object.keys(this.alreadyReportedToday).length === Object.keys(this.persons).length
    },
    canSubmit () {
      const anySymptom = Object.keys(this.reportedSymptoms).length > 0
      return this.noSymptoms || anySymptom
    },
    instance () {
      return this.instancesInfo[this.instanceID]
    },
    ...mapState({
      account: state => state.auth.account,
      uid: state => state.auth.uid,
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    isEditing: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.categoryInput.focus()
        })
      }
    },
  },
  mounted () {
    if (this.campaign) {
      this.name = this.campaign.name
      this.campaignTagIDs = this.campaign.tagIDs || {}
      this.dates = this.campaign.dates ? { start: this.campaign.dates.start.toDate().toISOString(), end: this.campaign.dates.end.toDate().toISOString() } : []
      this.form = this.campaign.form
      this.hours = this.campaign.notificationSettings.sendTime.hours
      this.minutes = this.campaign.notificationSettings.sendTime.minutes
    }
    // this.hours = this.instancesInfo[this.instanceID].notificationSettings?.sendTime?.hours
    // this.minutes = this.instancesInfo[this.instanceID].notificationSettings?.sendTime?.minutes
  },
  methods: {
    async save () {
      try {
        const data = {
          campaignID: this.campaignID,
          campaign: {
            instanceID: this.instanceID,
            name: this.name,
            tagIDs: this.campaignTagIDs,
            dates: {
              start: this.dates.start,
              end: this.dates.end,
            },
            form: this.form,
            metrics: {
              ...(this.campaign.metrics?.answeredBy && { answeredBy: this.campaign.metrics.answeredBy }),
            },
            notificationSettings: {
              enabled: true,
              ...(this.campaignID && { cronID: this.campaign.notificationSettings.cronID }),
              sendTime: {
                hours: String(this.hours),
                minutes: String(this.minutes),
              },
            },
          },
        }
        this.$f7.dialog.preloader('Guardando campaña')
        // console.info(data)
        await axios({
          url: '/campaigns/createOrEdit',
          method: 'POST',
          data,
        })
        this.$f7.dialog.close()
        this.$f7router.back()
      } catch (err) {
        console.error(err)
        this.$f7.dialog.close()
      }
    },
    onCategoryChange (e) {
      this.$set(this.form.categories, e.categoryID, e.category)
    },
    onCategoryDelete (e) {
      delete this.$delete(this.form.categories, e.categoryID)
      this.form.categoryIDs.splice(this.form.categoryIDs.indexOf(e.categoryID), 1)
    },
    async addTag (tagID) {
      this.$set(this.campaignTagIDs, tagID, true)
    },
    async removeTag (tagID) {
      this.$delete(this.campaignTagIDs, tagID)
    },
    async onSubmit () {
      const categoryID = db.collection('campaigns').doc().id
      this.$set(this.form.categories, categoryID, { name: this.editingValue, fields: {}, fieldIDs: [] })
      this.form.categoryIDs.push(categoryID)
      this.editingValue = ''
      this.isEditing = false
      this.$f7.dialog.close()
    },
  },
}
</script>
<style lang='scss'>
@import '../css/brand';
</style>
